import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#00A185",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m16 10.133-1.176.818.415-1.37-1.141-.866 1.431-.029.47-1.353.471 1.353 1.432.03-1.141.865.414 1.37zM11.334 11.2l-.784.545.276-.913-.76-.577.954-.02.314-.902.313.902.955.02-.761.576.276.914zm9.333 0-.784.545.276-.913-.76-.577.954-.02.313-.902.314.902.955.02-.761.576.276.914zm-12 2.667-.784.545.276-.914-.76-.577.954-.02.314-.901.313.902.955.02-.761.576.276.914zm14.667 0-.784.545.276-.914-.76-.577.954-.02.314-.901.313.902.955.02-.761.576.276.914z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M16 12a4.87 4.87 0 0 0-1.622 3.647c0 .99.291 1.912.79 2.678a4.9 4.9 0 0 1-.977-2.945c0-.737.16-1.435.448-2.06a1.94 1.94 0 0 1-.434-.771 4.9 4.9 0 0 0-.605 2.37c0 1.072.34 2.062.915 2.862a5.4 5.4 0 0 0-4.23-1.75q.239.229.39.53a5.4 5.4 0 0 1 3.96 1.745 5.38 5.38 0 0 0-3.522-1.315A5.3 5.3 0 0 0 9 17.425c.669 1.82 2.377 3.115 4.376 3.115q.195 0 .385-.017a4.57 4.57 0 0 1-4.08-1.277q-.264.106-.56.125A4.61 4.61 0 0 0 12.628 21 4.6 4.6 0 0 0 16 19.518 4.6 4.6 0 0 0 19.373 21a4.61 4.61 0 0 0 3.505-1.63 1.8 1.8 0 0 1-.559-.124 4.59 4.59 0 0 1-4.08 1.277q.19.016.385.017c2 0 3.707-1.296 4.376-3.115a5.3 5.3 0 0 0-2.113-.434c-1.34 0-2.568.494-3.523 1.315a5.4 5.4 0 0 1 3.961-1.746q.152-.3.39-.528a5.4 5.4 0 0 0-4.23 1.75 4.9 4.9 0 0 0 .915-2.863c0-.861-.22-1.67-.605-2.37a1.94 1.94 0 0 1-.434.771c.287.625.448 1.323.448 2.06 0 1.109-.364 2.13-.977 2.945.499-.766.79-1.687.79-2.678A4.87 4.87 0 0 0 16 12c.993.884 0 0 0 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M19.06 25.333A7.3 7.3 0 0 1 16 26a7.3 7.3 0 0 1-3.06-.667zm1.158-.666h-8.435a7 7 0 0 1-.816-.667h10.067a7.4 7.4 0 0 1-.816.667m1.44-1.334H10.342a7 7 0 0 1-.49-.666h12.295a7 7 0 0 1-.49.666M22.533 22H19.07c-1.169 0-2.24-.472-3.07-1.254-.83.782-1.9 1.254-3.07 1.254H9.467a7 7 0 0 1-.243-.526h3.486c1.275 0 2.435-.56 3.29-1.474.856.913 2.015 1.474 3.29 1.474h3.487a7 7 0 0 1-.243.526",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagMac = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagMac_default = SvgFlagMac;

export { FlagMac_default as default };
